/* eslint-disable no-unused-vars */
export enum LitigationServiceEndpoints {
  ASSIGN_LITIGATION = 'assignLitigation',
  DEASSIGN_LITIGATION = 'deassignLitigation',
  EXCLUDE_LITIGATION_FROM_GROUP = 'excludeLitigationFromGroup',
  REPORT_ISSUE = 'reportIssue',
  LIST_OF_TOPICS = 'listOfTopics',
  UPDATE_TOPIC = 'updateTopic',
  LIST_OF_ENTITIES = 'listOfEntities',
  UPDATE_ENTITY = 'updateResponsibleEntity',
  DEACTIVATE_LITIGATION = 'deactivateLitigation',
  REACTIVATE_LITIGATION = 'reactivateLitigation',
  LIST_OF_PROCEDURAL_ACTS = 'listOfProceduralActs',
  UPDATE_PROCEDURAL_ACT = 'updateProceduralAct',
  HISTORY_LIST_OF_ACTION_LITIGATION = 'historyListOfActionsOnLitigation',
  DISPLAY_LITIGATION_METADATA = 'displayLitigationMetadata',
  EXPORT_LITIGATION = 'exportLitigations',
  UNARCHIVE_LITIGATION = 'unarchiveLitigation',
  DOWNLOAD_LITIGATION_DOCUMENT = 'downloadLitigationDocument',
}
